import { Alert, type AlertProps } from '@remotely/ui-kit';
import type { ReactElement } from 'react';
import { ApiError, type ApiErrorSingle } from '~/api';
import { parseError } from '~/utils/format';

export function ErrorAlert({
    errors = [],
    formatError,
    children,
    ...alertProps
}: Omit<AlertProps, 'variant'> & ErrorsProps): ReactElement {
    return (
        <div
            className='error-alert'
            data-test-component='ui/Alert/ErrorAlert'>
            <Alert
                {...alertProps}
                variant='error'>
                {children}
                <Errors
                    errors={errors}
                    formatError={formatError}
                />
            </Alert>
        </div>
    );
}

type ErrorsProps = {
    errors?: ApiError | null;
    formatError?: (e: string) => string;
};

export function Errors({ errors = [], formatError = (e) => e }: ErrorsProps): ReactElement | null {
    if (!errors) {
        return null;
    }

    return (
        <>
            {[errors]
                .flat()
                .map((e) => parseError(e as ApiErrorSingle).message)
                .filter(Boolean)
                .map((e, i) => (
                    <span key={`alert_error_${i}`}>{formatError(e!)}</span>
                ))}
        </>
    );
}
